class Filter {
  constructor (el) {
    this.el = el
    this.searchInputContainer = this.el.querySelector('.js-filter-search-input')
    this.searchInput = this.searchInputContainer.querySelector('input')
    this.searchClearBtn = this.el.querySelector('.js-filter-search-clear')

    this.initDefaults()
  }

  initDefaults () {
    this.initEvents()
  }

  initEvents () {
    this.searchInput.addEventListener('input', e => this.onSearchInput(e))
    this.searchClearBtn.addEventListener('click', e => this.clearSearch(e))
  }

  onSearchInput (e) {
    this.searchInputContainer.classList.add('active')
  }

  clearSearch (e) {
    e.preventDefault()
    this.searchInput.value = ''
    this.searchInputContainer.classList.remove('active')
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.js-filter')

  if (el) {
    new Filter(el)
  }
})